<template>
	<div class="w_grid-000" data-tmpleditable="editable" style="margin-top: 130px;">
		<!-- <div class="news_header"></div> -->
		<div class="news-header">
			<div>新闻资讯</div>
			<div style="display: flex;flex-direction: row;font-weight: normal;">
				<div class="line"></div>
				<div class="title" style="font-size: 18px;padding: 0 15px;">Social Responsibility</div>
				<div class="line"></div>
			</div>
			<!-- 新闻 -->
		</div>
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="公司新闻" name="first">
				<div v-loading="isLoading" element-loading-text="加载中，请稍候..." element-loading-spinner-color="#56B275"
					element-loading-background="rgba(255, 255, 255, 0.8)"
					style="position: relative; min-height: 100vh;">
					<div v-for="(item, index) in newsSwipper" :key="index" style="margin-bottom: 30px;padding: 0 4vw;">
						<div class="news_img">
							<img :src="item.url" alt="" style="max-width: 379px; height: auto;">
							<div
								style="display: flex;flex-direction: column;margin-left: 80px;color: black;flex-wrap: wrap;">
								<div class="news_title">{{ item.title }}</div>
								<div class="news_content" v-html="processContent(item.content)"></div>
								<div class="news_btn" @click="goDetail(item)">查看详情</div>
							</div>
						</div>
					</div>
				</div>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total"
					style="text-align: center;margin-top: 20px;margin-bottom: 80px;">
				</el-pagination>
			</el-tab-pane>
			<el-tab-pane label="行业资讯" name="third">
				<div v-loading="isLoading1" element-loading-text="加载中，请稍候..." element-loading-spinner-color="#56B275"
					element-loading-background="rgba(255, 255, 255, 0.8)"
					style="position: relative; min-height: 100vh;">
					<div v-for="(item, index) in newsSwipper2" :key="index" style="margin-bottom: 30px;padding: 0 4vw;">
						<div class="news_img">
							<img :src="item.url" alt="" style="max-width: 379px; height: auto;">
							<div
								style="display: flex;flex-direction: column;margin-left: 80px;color: black;padding-right: 20px;flex-wrap: wrap;">
								<div class="news_title">{{ item.title }}</div>
								<div class="news_content" v-html="processContent(item.content)"></div>
								<div class="news_btn" @click="goDetail(item)">查看详情</div>
							</div>
						</div>
					</div>
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
						:current-page="page2" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize2"
						layout="total, sizes, prev, pager, next, jumper" :total="total2"
						style="text-align: center;margin-top: 20px;margin-bottom: 80px;">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="院校合作" name="second">
				<div v-loading="isLoading2" element-loading-text="加载中，请稍候..." element-loading-spinner-color="#56B275"
					element-loading-background="rgba(255, 255, 255, 0.8)"
					style="position: relative; min-height: 100vh;">
					<div v-for="(item, index) in newsSwipper3" :key="index" style="margin-bottom: 30px;padding: 0 4vw;">
						<div class="news_img">
							<img :src="item.url" alt="" style="max-width: 379px; height: auto;">
							<div
								style="display: flex;flex-direction: column;margin-left: 80px;color: black;padding-right: 20px;flex-wrap: wrap;">
								<div class="news_title">{{ item.title }}</div>
								<div class="news_content" v-html="processContent(item.content)"></div>
								<!-- <div class="news_btn" @click="goDetail(item)">查看详情</div> -->
							</div>
						</div>
					</div>
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
						:current-page="page2" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize2"
						layout="total, sizes, prev, pager, next, jumper" :total="total2"
						style="text-align: center;margin-top: 20px;margin-bottom: 80px;">
					</el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>

</template>

<script>
import '@/assets/css/page_impt_news.css'
import {
	getnews
} from '@/api'
export default {
	data() {
		return {
			activeName: 'first',
			typeItem: [],
			dataList: [],
			value: '公司新闻',
			page: 1,
			pageSize: 5, // 每页显示数量
			total: 0,
			newsSwipper: [
			],
			newsSwipper2: [],
			newsSwipper3: [],
			page2: 1,
			pageSize2: 5, // 每页显示数量
			total2: 0,
			isLoading: false,
			isLoading1: false,
			isLoading2: false,
		}
	},
	computed: {
		// 计算当前页要展示的数据
		paginatedNews() {
			const startIndex = (this.page - 1) * this.pageSize;
			const endIndex = startIndex + this.pageSize;
			return this.newsSwipper.slice(startIndex, endIndex);
		}
	},
	mounted() {
		this.getnews()
		this.getnews2()
		this.getnews3()
	},
	methods: {
		processContent(content) {
			if (!content) return '';
			// 只移除 img 标签，保留其他内容
			return content.replace(/<img[^>]*>/gi, '');
		},
		changeLanguage() {
			console.log("中文英文切换")
			this.$i18n.locale == 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh' //设置中英文模式
			localStorage.setItem('languageSet', this.$i18n.locale) //将用户设置存储到localStorage以便用户下次打开时使用此设置
		},
		goDetail(item) {
			this.$router.push({
				name: 'newDetail',
				params: item
			});
		},
		// 获取新闻
		getnews() {
			this.isLoading = true
			getnews({
				page: this.page,
				pageSize: this.pageSize,
				type: '公司新闻'
			}).then((res) => {
				const totalStr = res.headers['x-total-count'];
				this.total = Number(totalStr);
				this.newsSwipper = res.data; // 假设接口返回数据在 list 里
				this.total = res.data.length; // 假设接口返回总条数在 total 里
				this.isLoading = false
			})
		},
		// 每页条数改变时触发
		handleSizeChange(val) {
			this.pageSize = val;
			this.page = 1; // 切换每页条数时，重置页码为 1
			this.getnews(); // 重新获取数据
		},
		handleSizeChange2(val) {
			this.pageSize2 = val;
			this.page2 = 1; // 切换每页条数时，重置页码为 1
			this.getnews2(); // 重新获取数据
		},
		// 当前页码改变时触发
		handleCurrentChange(val) {
			this.page = val;
			this.getnews(); // 重新获取数据
		},
		handleCurrentChange2(val) {
			this.page2 = val;
			this.getnews2(); // 重新获取数据
		},
		// 获取行业新闻
		getnews2() {
			this.isLoading1 = true
			getnews({
				page: this.page2,
				pageSize: this.pageSize2,
				type: '行业资讯'
			}).then((res) => {
				this.newsSwipper2 = res.data; // 假设接口返回数据在 list 里
				this.total2 = res.data.length; // 假设接口返回总条数在 total 里
				this.isLoading1 = false
			})
		},
		getnews3() {
			this.isLoading2 = true
			getnews({
				page: this.page2,
				pageSize: this.pageSize2,
				type: '院校合作'
			}).then((res) => {
				this.newsSwipper3 = res.data; // 假设接口返回数据在 list 里
				this.total2 = res.data.length; // 假设接口返回总条数在 total 里
				this.isLoading2 = false
			})
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep .el-loading-spinner .circular .path {
	stroke: #56B275 !important;
	/* 圈圈的边框颜色 */
}

/* 若加载文字也需要改颜色，可添加以下代码 */
::v-deep .el-loading-text {
	color: #56B275 !important;
	/* 加载文字颜色 */
}

::v-deep .el-tabs__item.is-active {
	color: #66B782;
	background-color: white;
}

::v-deep .el-tabs__item.is-active:hover {
	color: #66B782;
}

::v-deep .el-tabs__item:hover {
	color: #66B782;
	background-color: white;
}

::v-deep .el-tabs__item {
	background-color: #66B782;
	color: white;
}

::v-deep .el-pager li.active {
	color: #66B782;
}

// .news_header {
// 	width: 100%;
// 	height: 520px;
// 	background: url(../assets/furuiImg/news.jpg);
// 	background-size: cover;
// 	background-position: center;
// 	// margin-bottom: 50px;
// 	// margin-top: 80px;
// }

.line {
	flex: 1;
	height: 2px;
	background: #000;
	width: 50px;
	align-items: center;
	display: flex;
	margin-top: 12px;
}

.news-header {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	// margin-top: 100px;
	font-size: 25px;
	font-weight: bold;
	color: black;
	padding: 50px 100px;
}

.news_img {
	// width: 30vw;
	// height: 10vw;
	// height: 245px;
	object-fit: cover;
	display: flex;
	flex-direction: row;
	// flex-wrap: wrap;
	// margin-right: 100px;
	border-bottom: 1px solid #ccc;
	padding-bottom: 30px;
	padding-top: 30px;
}

.news_img:hover {
	border: 1px solid #ccc;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.news_img:hover .news_btn {
	width: 200px;
	background-color: #66B782;
	color: white;
}

.news_title {
	font-weight: bolder;
	font-size: 26px;
	margin-bottom: 10px;
}

.news_content {
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-wrap: break-word;
	word-break: break-all;
	font-size: 20px;
	line-height: 1.5;
	padding-right: 50px;
	// border: 1px solid red;
	// max-width: 55vw;
}

.news_btn {
	display: block;
	width: 140px;
	line-height: 50px;
	background: #f9f9f9;
	color: #333;
	text-align: center;
	border-radius: 8px;
	transition: all ease .5s;
	margin-top: 40px;
	cursor: pointer;
}
</style>